// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AllDownloadsItemInfo__container-f32654 {
  margin-inline-start: 12px;
  width: 100%;
  overflow: hidden;
}

.AllDownloadsItemInfo__file-name-c04956 {
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
}

.AllDownloadsItemInfo__bytes-ad9405 {
  color: var(--base-80);
  min-width: 100px;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/AllDownloads/AllDownloadsItem/AllDownloadsItemInfo/AllDownloadsItemInfo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,qBAAA;EACA,gBAAA;EACA,4BAAA;EACA,8CAAA;AACF","sourcesContent":[".container {\n  margin-inline-start: 12px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.file-name {\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 100%;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n}\n\n.bytes {\n  color: var(--base-80);\n  min-width: 100px;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AllDownloadsItemInfo__container-f32654`,
	"file-name": `AllDownloadsItemInfo__file-name-c04956`,
	"fileName": `AllDownloadsItemInfo__file-name-c04956`,
	"bytes": `AllDownloadsItemInfo__bytes-ad9405`
};
module.exports = ___CSS_LOADER_EXPORT___;
